import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import ConfirmDialog from '@/components/atoms/ConfirmDialog/ConfirmDialog';
import { useAccount } from '@/hooks/useAccount';
import { useCloseModal } from '@/hooks/useCloseModal';
import useMembers from '@/hooks/useMembers';

interface Props {
  user_id: string;
}

const ModalAccountTransfer = ({ user_id }: Props) => {
  const { t } = useTranslation();
  const { transferOwnership, transferOwnershipStatus } = useAccount();
  const { members } = useMembers();
  const newOwner = members.find((m) => m.user_id === user_id);
  const closeModal = useCloseModal();

  useEffect(() => {
    if (transferOwnershipStatus === 'success') {
      closeModal();
    }
  }, [transferOwnershipStatus, closeModal]);

  return (
    <ConfirmDialog
      title={t('account.transfer.title')}
      subtitle={t('account.transfer.warning', { 0: newOwner?.name })}
      primaryButtonText={t('account.transfer.action')}
      secondaryButtonText={t('common.back_to_safety')}
      onConfirm={() => transferOwnership({ new_owner_id: user_id })}
      isLoading={transferOwnershipStatus === 'pending'}
      closeOnConfirm={false}
      submitOnEnter
    />
  );
};

export default ModalAccountTransfer;
